$(".c-form__error").hide();

$(".js-datepicker").datepicker({
    language: "ja",
    format: "yyyy/mm/dd",
    autoclose: true,
});
$(".js-timepicker").timepicker({
    timeFormat: "H:i"
});

$.fn.autoKana("#last_name", "#last_kana", { katakana: true });
$.fn.autoKana("#first_name", "#first_kana", { katakana: true });

// file 選択
const maxsize = 1024 * 1024 * 3; //3MB
$(".p-staffGuideForm__input--file").on("change", function () {
    var name = this.files[0].name;
    var showname = $(this).parents(".js-file-block").find(".js-file-change");
    showname.text(name);

    if (this.files[0].size > maxsize) {
        alert("3MB以内で選択してください。");
        $(this).val(null);
        showname.text("ファイルが選択されていません");
    }
});

// file delete
$(".p-staffGuideForm__delete").on("click", function () {
    $(this).prev(":input").val("");
    $(this).parents(".js-file-block").find(".js-file-change").text("ファイルが選択されていません");
});

// submit
$(".c-button--view").on("click", function () {
    $(".c-form__error").hide();

    const form = document.getElementById("contactForm");
    const fd = new FormData(form);
    $.ajax({
        type: "POST",
        url: this.dataset.url,
        data: fd,
        processData: false,
        contentType: false,
    }).done((res) => {
        if (res == true) {
            $(form).trigger("submit");
            return;
        }

        if (Object.keys(res).length > 0) {
            alert("エラーがあります。確認してください");
            $(".js-error-text").text(null);
            $("input").removeClass("c-inputText--error");
            $("textarea").removeClass("c-inputTextArea--error");

            $.each(res, function (key, val) {
                var name = `[name="${key}"]`;
                var msg_class = $(name).siblings(".c-form__error");

                for (let k of ['event_start', 'event_end', 'other_start', 'other_end']) {
                    if (key.indexOf(k) !== -1) {
                        msg_class = $(`[data-error=${k}]`);
                    }
                }

                if (key.indexOf("_path") !== -1) {
                    msg_class = $(name).parents(".js-file-error").siblings(".c-form__error");
                }
                if (key == "content") {
                    $(name).addClass("c-inputTextArea--error");
                }
                msg_class.find(".js-error-text").text(val);
                $(name).addClass("c-inputText--error");
                msg_class.show();
            });
        }
    }).fail(() => {
        alert("通信に失敗しました");
    });
});

// 期間入力
$("[data-target]").on('change', function () {
    const target = $(`[data-content=${this.dataset.target}]`);
    if (target[0].dataset.value == this.value) {
        target.show();
    } else {
        target.hide();
        target.val(null);
    }
}).filter(":checked").trigger("change");

$('input[name="main_day_type"]').on('change', function () {
    const target = $(`[data-content=${this.dataset.target}]`);
    if (target[0].dataset.value == this.value) {

        $('.js-target').addClass('u-wrapSp');
    } else {

        $('.js-target').removeClass('u-wrapSp');
    }
}).filter(":checked").trigger("change");

$('input[name="other_day_type"]').on('change', function () {
    const target = $(`[data-content=${this.dataset.target}]`);
    if (target[0].dataset.value == this.value) {

        $('.js-target2').addClass('u-wrapSp');
    } else {

        $('.js-target2').removeClass('u-wrapSp');
    }
}).filter(":checked").trigger("change");